module.exports = __webpack_public_path__ + "img/downtime-planned.22357a3e.svg";